import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ExecutionResultAdapter, ExecutionResultDto } from 'src/app/_models/execution-result-model';
import { map } from 'rxjs/operators';
import { QueryBuilderFilterDtoRequest } from 'src/app/_models/query-builder-filters/query-builder-filter-dto-request';

@Injectable({
    providedIn: 'root'
  })
export class QueryBuilderFilterService {
  //The applied filter and the selected saved filter are kept per page,
  //otherwise the state of one page (e.g. Messages) leaks into another one (e.g. Contacts)
  private appliedFilters = new Map<string, string>();
  private selectedFilters = new Map<string, number>();
  private _baseUrl = environment.apiURL;

  constructor(
    private http: HttpClient,
    private executionResultAdapter: ExecutionResultAdapter
  ) {  }

  //Returns the SQL of the filter currently applied to the given page
  getAppliedFilter(pageTitle: string): string {
    return this.appliedFilters.get(pageTitle || '') || '';
  }

  setAppliedFilter(pageTitle: string, sqlQuery: string): void {
    this.appliedFilters.set(pageTitle || '', sqlQuery || '');
  }

  //Returns the id of the saved filter currently selected on the given page
  getSelectedFilter(pageTitle: string): number {
    return this.selectedFilters.get(pageTitle || '') || 0;
  }

  setSelectedFilter(pageTitle: string, filterId: number): void {
    this.selectedFilters.set(pageTitle || '', filterId || 0);
  }

  //Drops the selected saved filter of every page
  clearSelectedFilters(): void {
    this.selectedFilters.clear();
  }

  getFiltersByPageTitle(pageTitle: string) {
    return this.http
    .get(this._baseUrl + 'QueryBuilder/GetSavedFilters?pageTitle=' + pageTitle)
    .pipe(map((data: any) => this.executionResultAdapter.adapt(data)));
  }

  addFilter(queryBuilderFilterDto: QueryBuilderFilterDtoRequest) {
    return this.http.post(this._baseUrl + 'QueryBuilder/AddFilter', queryBuilderFilterDto).pipe(map((data: any) =>
    this.executionResultAdapter.adapt(data)));
  }

  updateFilter(queryBuilderFilterDto: QueryBuilderFilterDtoRequest) {
    return this.http.post(this._baseUrl + 'QueryBuilder/UpdateFilter', queryBuilderFilterDto).pipe(map((data: any) =>
    this.executionResultAdapter.adapt(data)));
  }

  saveAsFilter(queryBuilderFilterDto: QueryBuilderFilterDtoRequest) {
    return this.http.post(this._baseUrl + 'QueryBuilder/SaveAsFilter', queryBuilderFilterDto).pipe(map((data: any) =>
      this.executionResultAdapter.adapt(data)));
  }
}
